import { render, staticRenderFns } from "./MerchantCategory.vue?vue&type=template&id=1009c5be&"
import script from "./MerchantCategory.vue?vue&type=script&lang=js&"
export * from "./MerchantCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports